import styled from '@emotion/styled';

export const UserProfileContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  background-color: #6e819810;
  padding: 3.6rem 2.4rem;
  border-radius: 0.4rem;
`;
